export const ASSESSMENTS_AND_RESEARCH_PAGES_ORDER_FOR_PERMISSIONS: string[] = [
  'survey',
  'survey_registration',
  'public_agent_module_permission',
  'group_module_permission',
]
